import * as queries from './task-template.queries';
import * as mutations from './task-template.mutations';
import * as api from './task-template.api';

export * from './task-template.api';
export * from './task-template.queries';
export * from './task-template.mutations';

export default { ...api, ...queries, ...mutations };
